<template>
    <div class="popup requests visible" id="export-popup">
        <div class="popup-box">
            <p class="h2 title">Save file to XLS?</p>
            <p class="subtitle">Specify the period</p>
            <div class="field-wrap">
                <div class="field start-date">
                    <label class="field-name">From</label>
                    <date-time-picker class="form-control datepicker no-icon" v-model="startDate" :options="dateOptions" placeholder="Select date"/>
                </div>
                <div class="field finish-date">
                    <label class="field-name">To</label>
                    <date-time-picker class="form-control datepicker no-icon" v-model="finishDate" :options="dateOptions" placeholder="Select date"/>
                </div>
            </div>
            <div class="buttons-box">
                <span class="btn success" @click="confirmClick">
                    <icon-base width="25" height="24" viewBox="0 0 25 24"><icon-save/></icon-base>
                    <span>SAVE</span>
                </span>
            </div>
            <span class="js-close-popup" @click="closeDialog">
                <icon-base width="20" height="20" viewBox="0 0 20 20"><icon-cross-2 color="#4D4D4F"/></icon-base>

            </span>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import DateTimePicker from "./DateTimePicker";
import IconBase from "./IconBase";
import IconCross2 from "./icons/IconCross2";
import IconSave from "./icons/IconSave";

export default {
    name: 'save-dialog-range',

    components: {IconSave, IconCross2, IconBase, DateTimePicker },
    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
    },
    data() {
        return {
            dateOptions: {
                timepicker: false,
                format: 'Y-m-d',
            },
            startDate: '',
            finishDate: ''
        }
    },

    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        confirmClick() {
            let date = {};
            date.from = this.startDate;
            date.to = this.finishDate;
            this.popupData.func(date).then(() => {
                this.switchPopup(false);
            });
        },
        closeDialog() {
            this.switchPopup(false);
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .js-close-popup {
        cursor: pointer;
    }
</style>
